<span class="text-truncate" [style.--line-clamp]="maxLine">{{ formatText }}</span>
